/* unplugin-vue-components disabled */import script from "./productProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./productProducts.vue?vue&type=script&lang=ts&setup=true"

import "./productProducts.vue?vue&type=style&index=0&id=43b71721&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b71721"]])

export default __exports__